function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import findAndDecorateImageProps from '../utils/findAndDecorateImageProps';

var HeroBanner = /*#__PURE__*/function (_PureComponent) {
  _inherits(HeroBanner, _PureComponent);

  var _super = _createSuper(HeroBanner);

  function HeroBanner() {
    _classCallCheck(this, HeroBanner);

    return _super.apply(this, arguments);
  }

  _createClass(HeroBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          primaryArt = _this$props.primaryArt,
          background = _this$props.background,
          gameLogo = _this$props.gameLogo;
      return /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor psw-fill psw-l-line-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-bottom-left', 'psw-l-bottom-left', 'psw-fill-x', 'psw-clip', 'psw-fill-y-9/10')
      }, findAndDecorateImageProps(background, {
        qa: "".concat(qa, "#background"),
        className: 'psw-fill',
        aspectRatio: '16:9',
        fit: 'cover',
        place: 'center',
        type: 'image'
      }, {
        parentClassNames: 'psw-fill'
      })), /*#__PURE__*/React.createElement("div", {
        className: "psw-l-grid psw-l-line-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/4', 'psw-l-w-1/3@tablet-s', 'psw-l-w-5/24@desktop', 'psw-l-w-5/24@max')
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-7/12', 'psw-l-w-3/4@mobile-l', 'psw-l-w-1/2@tablet-s', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/3@laptop', 'psw-l-w-7/24@desktop', 'psw-l-w-7/24@max')
      }, findAndDecorateImageProps(primaryArt, {
        qa: "".concat(qa, "#primaryArt"),
        aspectRatio: '1:1',
        type: 'image'
      }, {
        parentClassNames: 'psw-fill-x psw-l-line-left'
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-bottom-left', 'psw-l-bottom-left', 'psw-fill-x', 'psw-fill-y-9/10')
      }, /*#__PURE__*/React.createElement("div", {
        className: "psw-l-grid psw-l-gap-y-0 psw-fill psw-l-line-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-line-center', 'psw-l-w-1/2', 'psw-l-w-1/3@tablet-s', 'psw-l-w-1/4@tablet-l', 'psw-l-w-1/4@laptop', 'psw-l-w-5/24@desktop', 'psw-l-w-5/24@max')
      }, findAndDecorateImageProps(gameLogo, {
        qa: "".concat(qa, "#gameLogo"),
        aspectRatio: '1:1',
        fit: 'cover',
        type: 'image'
      }, {
        parentClassNames: 'psw-fill-x psw-l-line-left'
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/2', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/3@laptop', 'psw-l-w-7/24@desktop', 'psw-l-w-7/24@max')
      }))));
    }
  }]);

  return HeroBanner;
}(PureComponent);

HeroBanner.defaultProps = {
  qa: 'heroBanner'
};
HeroBanner.propTypes = {
  qa: PropTypes.string,
  primaryArt: PropTypes.element.isRequired,
  background: PropTypes.element.isRequired,
  gameLogo: PropTypes.element.isRequired
};
export default HeroBanner;